module.exports = __webpack_public_path__ + "static/img/nav_logo.0a62d0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav_logo.png
// module id = bptX
// module chunks = 12